import { LayoutHOC } from 'base/ui/layout/layout';
import { HomePage } from './home';

export const createHomePage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(HomePage);
}
